import { isMultiIntentSession } from '@pano-project/utils/intentMapping';

/**
 * The start-up check that replaces Cashier with a full-page "try again with a
 * lower amount" error when a paying-out session's pre-set amount is above the
 * balance.
 *
 * A multi-intent session must keep both tabs, so it never raises this error:
 * the Withdrawal tab shows the inline balance error instead. Every other
 * session keeps today's check unchanged.
 */
export const shouldRaiseStartupBalanceError = ({ type, base_amount, balance } = {}, state) =>
  !!(type === 'pay-out' && base_amount && balance && +base_amount > +balance) &&
  !isMultiIntentSession(state);
